<template>
  <a-layout id="components-layout-demo-responsive" :style="{ minHeight: '100vh' }">
    <a-layout-sider
      breakpoint="lg"
      collapsedWidth="0"
      @collapse="onCollapse"
      @breakpoint="onBreakpoint"
    >
      <div class="logo" />
      <a-menu
        theme="dark"
        mode="inline"
        :openKeys="openKeys"
        :defaultSelectedKeys="defaultRoute"
        :selectedKeys="defaultRoute"
        @click="routeFun"
        @openChange="openChange"
      >
        <a-menu-item key="index" v-if="[1, 4, 6].indexOf(userInfo.userType) !== -1">
          <a-icon type="home" />
          <span class="nav-text">首页</span>
        </a-menu-item>
        <a-menu-item key="media" v-if="[1, 4, 5, 6].indexOf(userInfo.userType) !== -1">
          <a-icon type="tablet" />
          <span class="nav-text">点位管理</span>
        </a-menu-item>
        <!-- <a-menu-item key="adPlan" v-if="userInfo.userType!=3">
                    <a-icon type="calendar"/>
                    <span class="nav-text">广告计划</span>
                </a-menu-item> -->
        <a-menu-item key="adPackage" v-if="userInfo.userType == 3">
          <a-icon type="inbox" />
          <span class="nav-text">广告包更新</span>
        </a-menu-item>
        <a-menu-item
          key="client"
          v-if="
            userInfo.userType == 1 ||
              userInfo.userType == 2 ||
              userInfo.userType == 6 ||
              userInfo.userType === 7
          "
        >
          <a-icon type="team" />
          <span class="nav-text">客户管理</span>
        </a-menu-item>
        <a-sub-menu key="channelManagement">
          <span slot="title"><a-icon type="calendar" /><span>投放管理</span></span>
          <a-menu-item key="channelAd"> 广告订单 </a-menu-item>
        </a-sub-menu>
        <a-menu-item v-if="[1, 5].indexOf(userInfo.userType) !== -1" key="tagsManagement">
          <a-icon type="tags" />
          <span class="nav-text">标签管理</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header :style="{ background: '#fff', padding: 0 }">
        <div class="header_box" ref="headerBox">
          <div class="message_box">
            <a-popover
              placement="bottomRight"
              trigger="click"
              overlayClassName="mes_body"
              @visibleChange="popoverVisible"
            >
              <template slot="content">
                <ul class="message_ul" ref="messageUl">
                  <li
                    class="message_ul_li clearfix"
                    :class="key.status === 1 ? 'message_readed' : ''"
                    v-for="(key, index) in messageList"
                    :key="index"
                    @click="updateReadStatus(key, 'one')"
                  >
                    <div class="left_img">
                      <img :src="key.avatar" alt="" />
                    </div>
                    <div class="right_info clearfix">
                      <h4>{{ key.title || '--' }}</h4>
                      <p v-dompurify-html="key.content"></p>
                      <p>{{ key.beforeTime }}</p>
                    </div>
                    <span class="detail_btn" @click="gotoDetail(key)">查看</span>
                  </li>
                </ul>
              </template>
              <template slot="title">
                <div class="title_body">
                  <span>消息({{ messageInfo.unread }}条未读)</span>
                  <span class="right_btn" @click="updateReadStatus('', 'total')">全部已读</span>
                </div>
              </template>
              <a-badge :count="messageInfo.unread">
                <a-icon type="bell" />
              </a-badge>
            </a-popover>
          </div>
          <a-dropdown>
            <div class="user-info">
              <!--                            <a-avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"/>-->
              <a-avatar
                :src="
                  userInfo.headPic
                    ? userInfo.headPic
                    : 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png'
                "
              />
              <p>
                <span>{{ userInfo.realName }}</span>
                <span>{{ userInfo.position }}</span>
              </p>
            </div>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="logOut">退出登录</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-layout-header>
      <a-layout-content>
        <div>
          <a-config-provider :locale="locale">
            <router-view v-if="isReloadAlive"></router-view>
          </a-config-provider>
        </div>
      </a-layout-content>
      <a-layout-footer style="text-align: center; color: #8a8a8a; padding: 64px 50px 32px">
        <a-icon type="home" style="margin-right: 2px; color: #8a8a8a" />
        <a style="color: #8a8a8a">回到首页</a> | Copyright 2019 亲邻科技线上产品部
      </a-layout-footer>
    </a-layout>

    <!-- 检测绑定微信登录-弹框组件 -->
    <CheckBindWxModal />
  </a-layout>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import api from '../../commomFun/api'
import CheckBindWxModal from '@/components/common/checkBindWxModal/index.vue'

export default {
  components: {
    CheckBindWxModal
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isReloadAlive: true,
      locale: zhCN,
      defaultRoute: [],
      openKeys: [],
      userInfo: '',
      // 消息通知信息
      messageInfo: {
        unread: 0
      },
      // 消息列表
      messageList: [],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0
      },
      loadScroll: true, // 前一次请求为完成时不执行滚动加载
      isAddEventListener: false
    }
  },
  mounted() {
    /**
     * 初始化数据
     */
    this.init()
    this.fixedRoute()
    // 消息总条数
    this.getMessageTotal()
    // 消息列表
    this.getMessageList()
  },
  methods: {
    // 角色类型userType： 1超管 2运营 3工程 4当地媒介 5全国媒介 6公司管理员
    init() {
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    },
    // 配置 breakpoint 属性即生效，视窗宽度小于 breakpoint 时 Sider 缩小为 collapsedWidth 宽度，若将 collapsedWidth 设置为零，会出现特殊 trigger
    onCollapse(collapsed, type) {},
    onBreakpoint(broken) {},
    // 获取消息未读总条数
    getMessageTotal() {
      api.getApi('/message/getNoReadCount', {}).then(res => {
        // console.log('未读数量res',res)
        if (res.data.code === 200) {
          this.messageInfo.unread = res.data.data
        } else {
          console.log(res.data.msg)
        }
      })
    },
    // 获取消息通知列表
    getMessageList() {
      let params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      }
      api.getApi('/message/page', params).then(res => {
        // console.log('获取消息通知列表res',res)
        if (res.data.code === 200 && res.data.data) {
          this.pageInfo.pageNum++
          let arr = []
          arr = res.data.data.list.map(item => {
            return {
              id: item.id,
              title: item.title,
              content: item.content.keyword1,
              sendDate: item.sendDate,
              beforeTime: item.beforeStr,
              status: item.status,
              type: item.type,
              avatar: item.avatar || require('../../../static/image/headimg.png'),
              url: item.url
            }
          })
          this.pageInfo.totalPage = res.data.data.totalPage
          this.messageList = this.messageList.concat(arr)
          this.loadScroll = true
        } else if (res.data.code !== 200) {
          this.$message.warning(res.data.msg || '消息通知异常')
        }
      })
    },
    // 更新消息通知状态
    updateReadStatus(item, String) {
      // console.log('更新状态---')
      let params = {
        allRead: false
      }
      if (String === 'one') {
        // 单个消息
        if (item.status === 1) {
          // 判断是否为已读状态
          return
        }
        params.allRead = false
        params.messageId = item.id
      } else {
        // 全部已读按钮
        if (this.messageInfo.unread <= 0) {
          this.$message.warning('暂无未读消息')
          return
        }
        params.allRead = true
        params.recipientId = this.userInfo.userId
      }
      api.postApi('/message/updateReadStatus', params).then(res => {
        // console.log('更改消息状态res',res)
        if (res.data.code === 200) {
          if (String === 'one') {
            item.status = 1
            this.messageInfo.unread--
          } else {
            this.messageInfo.unread = 0
            for (let key of this.messageList) {
              key.status = 1
            }
          }
        } else {
          this.$message.warning(res.data.msg || '消息状态更新异常')
        }
      })
    },
    // 弹出框初始化后进行滚动监听
    popoverVisible(val) {
      if (val && !this.isAddEventListener) {
        let timer = setTimeout(() => {
          let that = this
          this.$refs.messageUl.addEventListener('scroll', function() {
            const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
            if (scrollDistance <= 150) {
              that.loadMore()
            }
          })
          this.isAddEventListener = true
          clearTimeout(timer)
        }, 500)
      }
    },
    //监听table滚动
    loadMore() {
      if (this.loadScroll) {
        this.loadScroll = false
        if (this.pageInfo.pageNum <= this.pageInfo.totalPage) {
          this.getMessageList()
        }
      }
    },
    // 查看-跳转详情
    gotoDetail(item) {
      if (!item.url) {
        this.$message.warning('查看异常，url缺失')
        return
      }
      let id = item.url.split('=')[1]
      if (item.url.includes('mediaDetail')) {
        this.$router.push('/mediaDetail?pointId=' + id)
        if (this.$route.path.includes('/mediaDetail')) {
          this.reload()
        }
      } else {
        sessionStorage.setItem('planId', id)
        if (this.$route.path.includes('/channelAdPlanDetail')) {
          this.reload()
        } else {
          this.$router.push('/channelAdPlanDetail')
        }
      }
    },
    //点击导航
    routeFun(params) {
      if (params.key == 'index') {
        this.$router.push('/index')
        this.defaultRoute = ['index']
      } else if (params.key == 'media') {
        this.$router.push('/mediaList')
        this.defaultRoute = ['media']
      } else if (params.key == 'adPlan') {
        this.$router.push('/adPlanList')
        this.defaultRoute = ['adPlan']
      } else if (params.key == 'adPackage') {
        this.$router.push('/adPackage')
        this.defaultRoute = ['adPackage']
      } else if (params.key == 'client') {
        this.$router.push('/clientList')
        this.defaultRoute = ['client']
      } else if (params.key == 'channelAd') {
        this.$router.push('/channelAdPlan')
        this.defaultRoute = ['channelAd']
      } else if (params.key == 'tagsManagement') {
        this.$router.push('/tags')
        this.defaultRoute = ['tagsManagement']
      }
    },
    openChange(openKeys) {
      if (openKeys.length !== 0) {
        this.openKeys = [openKeys[0]]
      } else {
        this.openKeys = []
      }
    },
    //刷新页面固定导航
    fixedRoute() {
      let router = this.$router.currentRoute.path.toLowerCase()
      if (router.includes('media') || router.includes('readyplaylist')) {
        this.defaultRoute = ['media']
      } else if (router.includes('channeladplan')) {
        this.defaultRoute = ['channelAd']
        this.openKeys = ['channelManagement']
      } else if (router.includes('adplan')) {
        this.defaultRoute = ['adPlan']
      } else if (router.includes('adpackage')) {
        this.defaultRoute = ['adPackage']
      } else if (router.includes('client')) {
        this.defaultRoute = ['client']
      } else if (router.includes('tags')) {
        this.defaultRoute = ['tagsManagement']
      }
    },
    //退出登录
    logOut() {
      this.$router.push('/login')
    },
    //刷新当前页面
    reload() {
      this.isReloadAlive = false
      this.$nextTick(function() {
        this.isReloadAlive = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#components-layout-demo-responsive .logo {
  height: 24px;
  background-size: 100% 150% !important;
  background: url('../../../public/images/QFAD-logo.png') no-repeat;
  margin: 20px 50px;
}

.header_box {
  position: absolute;
  right: 39px;
  top: 0;
  display: flex;
  height: 64px;
  align-items: center;
  cursor: pointer;
}

#components-layout-demo-responsive .user-info {
  display: inline-block;
}

#components-layout-demo-responsive .user-info p {
  display: inline-block;
}

#components-layout-demo-responsive .user-info p span:nth-child(1) {
  color: #000000;
}

#components-layout-demo-responsive .user-info p span:nth-child(2) {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}

#components-layout-demo-responsive .ant-avatar {
  margin-right: 5px;
}

#components-layout-demo-responsive .ant-layout-header {
  box-shadow: 0px 2px 8px 0px rgba(20, 22, 26, 0.08);
  position: relative;
  z-index: 99;
}

/*消息通知*/
.message_box {
  width: 24px;
  height: 24px;
  position: relative;
  margin-right: 12px;

  .ant-badge {
    position: absolute;
    top: 4px;
    left: 4px;

    .anticon-bell {
      font-size: 20px;

      svg {
        font-size: 20px;
      }
    }

    /deep/ .ant-scroll-number.ant-badge-count {
      height: 18px;
      min-width: 18px;
      line-height: 18px;
      top: -6px;
      right: 4px;

      .ant-scroll-number-only {
        p {
          font-size: 12px;
        }
      }
    }
  }
}
.message_ul {
  width: 360px;
  max-height: 420px;
  min-height: 210px;
  overflow-y: auto;

  .message_ul_li {
    padding: 8px 16px;
    border-bottom: 1px solid rgba(232, 232, 232, 1);
    cursor: pointer;
    position: relative;

    .left_img {
      width: 14%;
      text-align: center;
      float: left;
      margin-left: 2%;

      img {
        width: 44px;
        height: 44px;
        border-radius: 50%;
      }
    }

    .right_info {
      width: 83%;
      float: right;
      padding: 0 8px;
      line-height: 26px;

      h4 {
        height: 26px;
        font-size: 16px;
        font-weight: 600;
        padding-right: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .right_info_span {
        font-size: 14px;
        font-weight: 600;
      }
    }

    .detail_btn {
      position: absolute;
      right: 8px;
      top: 8px;
      z-index: 9;
      font-size: 14px;
      color: rgba(24, 144, 255, 1);
      cursor: pointer;
    }
  }

  .message_readed {
    opacity: 0.5;
    cursor: unset;
  }
}
</style>
<style lang="scss">
.mes_body {
  .ant-popover-inner-content {
    padding: 2px;
  }
  .ant-popover-title {
    font-size: 14px;
    color: rgba(82, 82, 83, 1);
    .title_body {
      display: flex;
      span {
        width: 80%;
      }
      .right_btn {
        flex: 1;
        text-align: right;
        color: rgba(24, 144, 255, 1);
        cursor: pointer;
      }
    }
  }
}
</style>
